import { BreakpointAvailable } from '@shared/services/responsive';

const MIN_DESKTOP = 1000;

export const breakpoints: Record<BreakpointAvailable, string> = {
  mobile: `(max-width: ${MIN_DESKTOP - 0.02}px)`,
  desktop: `(min-width: ${MIN_DESKTOP}px)`,
};
